module.exports = {
    API_ENDPOINT: `https://color-generator-tool.onrender.com`,
    TOKEN_KEY: '',
}
